import React, { FC } from 'react';
import { Redirect } from 'react-router';
import { useGetApplication } from '~/controllers/wizard';
import { handleGetutm } from '~/utils/handleGetUtm';
import paths from '../paths';

const KsaFlow: FC<void> = () => {
  const { data }: any = useGetApplication();
  const utmParams = handleGetutm(data);

  return <Redirect to={`${paths.ksa.services}?${utmParams}`} />;
};

export default KsaFlow;
